/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductAssortmentGroupData
 */
export interface ProductAssortmentGroupData {
    /**
     * 
     * @type {ProductAssortmentGroupDataGroupEnum}
     * @memberof ProductAssortmentGroupData
     */
    group?: ProductAssortmentGroupDataGroupEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductAssortmentGroupData
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductAssortmentGroupData
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductAssortmentGroupData
     */
    share?: number;
}


/**
 * @export
 */
export const ProductAssortmentGroupDataGroupEnum = {
    A: 'A',
    B: 'B',
    C: 'C'
} as const;
export type ProductAssortmentGroupDataGroupEnum = typeof ProductAssortmentGroupDataGroupEnum[keyof typeof ProductAssortmentGroupDataGroupEnum];


/**
 * Check if a given object implements the ProductAssortmentGroupData interface.
 */
export function instanceOfProductAssortmentGroupData(value: object): value is ProductAssortmentGroupData {
    return true;
}

export function ProductAssortmentGroupDataFromJSON(json: any): ProductAssortmentGroupData {
    return ProductAssortmentGroupDataFromJSONTyped(json, false);
}

export function ProductAssortmentGroupDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductAssortmentGroupData {
    if (json == null) {
        return json;
    }
    return {
        
        'group': json['group'] == null ? undefined : json['group'],
        'count': json['count'] == null ? undefined : json['count'],
        'value': json['value'] == null ? undefined : json['value'],
        'share': json['share'] == null ? undefined : json['share'],
    };
}

export function ProductAssortmentGroupDataToJSON(json: any): ProductAssortmentGroupData {
    return ProductAssortmentGroupDataToJSONTyped(json, false);
}

export function ProductAssortmentGroupDataToJSONTyped(value?: ProductAssortmentGroupData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group': value['group'],
        'count': value['count'],
        'value': value['value'],
        'share': value['share'],
    };
}

